var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -222.7908,
    y1: 274.2915,
    x2: -222.6634,
    y2: 274.1651,
    gradientTransform: "matrix(189.3834 0 0 -189.8058 42198.0313 52067.0586)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#387EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#366994"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.8,0.5c-12.4,0-11.6,5.4-11.6,5.4l0,5.6H25v1.7H8.5c0,0-7.9-0.9-7.9,11.6c0,12.5,6.9,12.1,6.9,12.1h4.1 v-5.8c0,0-0.2-6.9,6.8-6.9h11.7c0,0,6.6,0.1,6.6-6.4V6.9C36.7,6.9,37.7,0.5,24.8,0.5L24.8,0.5L24.8,0.5z M18.3,4.2 c1.2,0,2.1,1,2.1,2.1s-1,2.1-2.1,2.1c-1.2,0-2.1-1-2.1-2.1C16.2,5.2,17.1,4.2,18.3,4.2L18.3,4.2L18.3,4.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -223.0609,
    y1: 274.549,
    x2: -222.9241,
    y2: 274.4194,
    gradientTransform: "matrix(189.3834 0 0 -189.8058 42264.0313 52131.3203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC331"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.2,49c12.4,0,11.6-5.4,11.6-5.4l0-5.6H24.9v-1.7h16.5c0,0,7.9,0.9,7.9-11.6c0-12.5-6.9-12.1-6.9-12.1h-4.1 v5.8c0,0,0.2,6.9-6.8,6.9H19.8c0,0-6.6-0.1-6.6,6.4v10.7C13.2,42.5,12.2,49,25.2,49L25.2,49L25.2,49z M31.7,45.3 c-1.2,0-2.1-1-2.1-2.1s1-2.1,2.1-2.1c1.2,0,2.1,1,2.1,2.1S32.8,45.3,31.7,45.3L31.7,45.3L31.7,45.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.911ecace7e52b3d1336e2285543a5ac3.svg";
export { ForwardRef as ReactComponent };